<template>
  <div id="ResourceLabels">
    <div class="nav-sub">
      <h4>
        Labels
      </h4>
      <ul>
        <li v-for="label in resourceLabels" :key="label.Id">
          <router-link :to="'/resourceLibrary?resourceLabelId=' + label.Id" exact>
            {{ label.Title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      resourceLabels: {
        type: Array,
        // default: () => ([])
        default: () => ([
          { Id: 1, Title: 'Label One' },
          { Id: 2, Title: 'Label Two' },
          { Id: 3, Title: 'Label Three' }
        ])
      }
    },
  }
</script>
<style scoped>
#ResourceLabels {
  width: 100%;
}
</style>